var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.37499 11C1.37499 11.1823 1.44742 11.3572 1.57635 11.4861C1.70529 11.6151 1.88016 11.6875 2.06249 11.6875H18.2779L13.9507 16.0132C13.8216 16.1423 13.7491 16.3174 13.7491 16.5C13.7491 16.6826 13.8216 16.8577 13.9507 16.9867C14.0798 17.1158 14.2549 17.1884 14.4375 17.1884C14.6201 17.1884 14.7951 17.1158 14.9242 16.9867L20.4242 11.4867C20.4883 11.4229 20.5391 11.347 20.5737 11.2635C20.6084 11.18 20.6262 11.0904 20.6262 11C20.6262 10.9096 20.6084 10.82 20.5737 10.7365C20.5391 10.653 20.4883 10.5771 20.4242 10.5132L14.9242 5.01325C14.8603 4.94933 14.7844 4.89862 14.7009 4.86403C14.6174 4.82944 14.5279 4.81163 14.4375 4.81163C14.2549 4.81163 14.0798 4.88415 13.9507 5.01325C13.8216 5.14234 13.7491 5.31743 13.7491 5.5C13.7491 5.68257 13.8216 5.85765 13.9507 5.98675L18.2779 10.3125H2.06249C1.88016 10.3125 1.70529 10.3849 1.57635 10.5139C1.44742 10.6428 1.37499 10.8177 1.37499 11Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.b49824b2903bff1b010a3e11162af1c2.svg";
export { ForwardRef as ReactComponent };